








































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { parse } from 'papaparse'
import moment from 'moment'
import ListView from '@/components/ListView.vue'
import DateSelect from '@/components/DateSelect.vue'
import ShopAutocomplete from '@/components/ShopAutocomplete.vue'
import CSVExportBtn from '@/components/CSVExport.vue'
import { Shop } from '@/types/shop'
import { formatDateForDisplay } from '@/utils'

const parseCSV = (file: File) => {
  return new Promise((resolve, reject) => {
    parse(file, {
      error: err => {
        reject(err)
      },
      complete: results => {
        return resolve(results.data)
      },
    })
  })
}

const transformCSV = (data: string[][], shops: Shop[]) => {
  const header = data[0]
  if (!header) return []
  const shopCodeIdx = header.findIndex(x => String(x).match('コード'))
  const dateIdx = header.findIndex(x => String(x).match('日'))
  const memoIdx = header.findIndex(x => String(x).match('メモ'))
  const code2id: Map<string, Shop> = new Map()
  shops.forEach(shop => {
    code2id.set(shop.code, shop)
  })
  data = data.slice(1)
  return data.map(row => {
    const shop = code2id.get(row[shopCodeIdx])
    const date = moment(row[dateIdx])
    return {
      isValid: Boolean(shop) && date.isValid(),
      shop: shop?.id,
      shopCode: row[shopCodeIdx],
      shopName: shop?.name,
      date: date.isValid() ? date.format('YYYY-MM-DD') : '',
      memo: row[memoIdx] || '',
    }
  })
}

@Component({
  components: { ListView, DateSelect, ShopAutocomplete, CSVExportBtn },
})
export default class HolidayView extends Vue {
  @Ref() readonly listView!: ListView

  filterDefinition = {
    ordering: { type: String, default: '' },
    shop: { type: String, default: null },
    dateFrom: { type: String, default: null },
    dateTo: { type: String, default: null },
  }
  filter: null | Record<string, any> = null
  selected: number[] = []

  get headers() {
    return [
      {
        text: this.$t('usedTicket.text.date'),
        value: (item: any) =>
          formatDateForDisplay(item.usedDate, this.$i18n.locale),
        width: 100,
      },
      {
        text: this.$t('usedTicket.text.shopCode'),
        value: 'shopCode',
        width: 60,
      },
      {
        text: this.$t('usedTicket.text.shopName'),
        value: 'shopName',
        width: 200,
      },
      {
        text: this.$t('usedTicket.text.customerCode'),
        value: 'customerCode',
        width: 100,
      },
      {
        text: this.$t('usedTicket.text.customerName'),
        value: 'customerName',
        width: 100,
      },

      { text: this.$t('usedTicket.text.ticketName'), value: 'name' },
      {
        text: this.$t('usedTicket.text.usedQuantity'),
        value: 'usedQuantity',
        width: 150,
      },
    ]
  }
  shops: Shop[] = []
  bulkData: {
    isValid: boolean
    shopCode: any
    shopName: any
    shop: any
    date: string
    memo: string
  }[] = []
  isUploading = false
  dialog = false
  get csvHeaders() {
    const t = this.$t.bind(this)
    return [
      { key: 'usedDate', label: t('usedTicket.csv.date') },
      { key: 'shopCode', label: t('usedTicket.csv.shopCode') },
      { key: 'shopName', label: t('usedTicket.csv.shopName') },
      { key: 'customerCode', label: t('usedTicket.csv.customerCode') },
      { key: 'customerName', label: t('usedTicket.csv.customerName') },
      { key: 'group', label: t('usedTicket.csv.ticketId') },
      { key: 'ecProductId', label: t('usedTicket.csv.ecProductId') },
      { key: 'name', label: t('usedTicket.csv.ticketName') },
      { key: 'usedQuantity', label: t('usedTicket.csv.usedQuantity') },
      { key: 'price', label: t('usedTicket.csv.price') },
      { key: 'quantity', label: t('usedTicket.csv.purchaseQuantity') },
      { key: 'ticket', label: t('usedTicket.csv.purchaseId') },
      { key: 'id', label: t('usedTicket.csv.usageId') },
    ]
  }
  created() {
    this.fetchShop()
  }
  updateQuery() {
    if (this.filter !== null) this.listView.updateQuery(this.filter)
    this.selected = []
  }
  async fetchShop(nextUrl?: string) {
    const { results, next } = await (nextUrl
      ? this.$api.http.get(nextUrl)
      : this.$api.shops().list())
    this.shops = this.shops.concat(results)
    if (next) this.fetchShop(next)
  }

  async onFileChanged(file: null | File) {
    console.log('onFileChanged', file)
    if (file) {
      const csvData = (await parseCSV(file)) as any[][]
      this.bulkData = transformCSV(csvData, this.shops)
    }
  }
  async upload() {
    this.isUploading = true
    try {
      await this.$api
        .holidays()
        .bulkUpload(this.bulkData.filter(x => x.isValid))
      this.bulkData = []
      this.$toast.success(String(this.$t('toast.message.uploadSuccess')))
      this.dialog = false
    } catch (err) {
      console.error(err)
      this.$toast.error(String(this.$t('toast.message.uploadFailed')))
    }
    this.isUploading = false
  }
}
